import { Helmet } from "react-helmet-async";

const aboutUs = [
    {
        icon: "no_crash",
        title: "Modern & Comfortable Fleet",
        description:
            "A diverse selection of premium vehicles designed to accommodate trips of all sizes.",
    },
    {
        icon: "person_pin_circle",
        title: "Customer-First Approach",
        description:
            "Every transportation solution is tailored to meet the unique needs of our clients.",
    },
    {
        icon: "handshake",
        title: "Reliable & On-Time Service",
        description:
            "We understand the value of your time and strive to deliver punctual, hassle-free transportation.",
    },
];

export const AboutUs = () => {

    return (
        <section className="bg-primary">
            <Helmet>
                <title>About Velox Charter | Trusted Charter Transportation Services</title>

                <meta
                    name="description"
                    content="Learn about Velox Charter and our commitment to safe, reliable, and professional
                     charter transportation services. Discover our modern fleet, experienced drivers, and
                      customer-first approach to corporate travel, airport transfers, special events, and group transportation."
                />
            </Helmet>

            <div className="max-w-7xl mx-auto px-4">
                <div className="h-[220px] md:h-[280px] flex items-center justify-center">
                    <h1 className="text-white text-4xl md:text-6xl font-bold text-center">
                        About Us
                    </h1>
                </div>

            </div>
            <section className="bg-[#F9FAFB] py-16 md:py-24">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                    {/* Header */}
                    <div className="text-center">
                        <h2 className="text-4xl md:text-5xl font-semibold text-black">
                            Driven by Service, Built on Trust
                        </h2>

                        <p className="mt-6 max-w-3xl mx-auto text-gray-500 text-base md:text-lg leading-relaxed">
                            We provide safe, reliable, and premium charter transportation solutions, helping individuals, businesses, and groups travel with confidence and comfort.
                        </p>
                    </div>

                    {/* Cards */}
                    <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 ">
                        {aboutUs.map((service, index) => (
                            <div
                                key={index}
                                className="xl:w-[320px] bg-white border border-[#D0D0D0] rounded-[17px] px-[14px] py-[16px] text-center flex flex-col gap-[6px]"
                            >
                                <span className="material-symbols-outlined text-[35px] text-secondryBlue">
                                    {service.icon}
                                </span>

                                <h3 className="mt-6 text-[16px] md:text-[17px]  font-medium text-secondryBlue">
                                    {service.title}
                                </h3>

                                <p className="mt-5 text-gray-500 text-[13px]">
                                    {service.description}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>


            <section className="bg-[#f5f5f5] py-16 lg:py-24">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                    {/* Section 1 */}
                    <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">

                        {/* Image */}
                        <div>
                            <img
                                src="/images/aboutus1.png"
                                alt="Who We Are"
                                className="
                                w-full
                                h-[300px]
                                md:h-[450px]
                                object-cover
                                rounded-[30px]
                            "
                            />
                        </div>

                        {/* Content */}
                        <div>
                            <h2 className="text-[36px] md:text-[52px] font-semibold text-black leading-tight">
                                Who We Are
                            </h2>

                            <div className="mt-6 space-y-4 text-[#666666] leading-8 text-base md:text-lg">
                                <p>
                                    At Velox Charter, we believe transportation should be
                                    more than simply getting from one place to another—it
                                    should be safe, comfortable, and stress-free.
                                </p>

                                <p>
                                    Our company was founded with a commitment to
                                    providing dependable charter services backed by
                                    exceptional customer care, professional drivers,
                                    and a modern fleet of vehicles.
                                </p>

                                <p>
                                    Whether you're planning corporate travel, airport
                                    transportation, special events, or private group
                                    trips, we work closely with every client to
                                    deliver personalized solutions that meet their
                                    unique travel needs.
                                </p>

                                <p>
                                    Our goal is to make every journey seamless from
                                    departure to destination.
                                </p>
                            </div>
                        </div>

                    </div>

                    {/* Section 2 */}
                    <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center mt-20 lg:mt-32">

                        {/* Content */}
                        <div className="order-2 lg:order-1">
                            <h2 className="text-[36px] md:text-[52px] font-semibold text-black leading-tight">
                                Our Commitment
                                <br />
                                to Excellence
                            </h2>

                            <div className="mt-6 space-y-4 text-[#666666] leading-8 text-base md:text-lg">
                                <p>
                                    We are dedicated to setting the standard for
                                    quality transportation services through
                                    reliability, safety, and attention to detail.
                                </p>

                                <p>
                                    Every vehicle in our fleet is regularly
                                    maintained and inspected to ensure a comfortable
                                    and secure travel experience for our passengers.
                                </p>

                                <p>
                                    By combining modern vehicles, experienced
                                    drivers, and a customer-first approach, we
                                    continue to earn the trust of individuals,
                                    businesses, and organizations seeking dependable
                                    charter transportation.
                                </p>

                                <p>
                                    No matter the size or purpose of your trip, our
                                    team is committed to delivering service you can
                                    rely on every mile of the way.
                                </p>
                            </div>
                        </div>

                        {/* Image */}
                        <div className="order-1 lg:order-2">
                            <img
                                src="/images/aboutus2.jpg"
                                alt="Commitment to Excellence"
                                className="
                                w-full
                                h-[300px]
                                md:h-[450px]
                                object-cover
                                rounded-[30px]
                            "
                            />
                        </div>

                    </div>

                </div>
            </section>
        </section>
    )
}